import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { formatDate } from '@angular/common';

@Injectable()
export class FileUploadService {

  constructor(private http: HttpClient) { }
  postFile(fileToUpload: File, domain, subDomain): Observable<any> {
    const endpoint = '/superadmin/rest/mgmt/account/makeAccount';
    const formData: FormData = new FormData();
    formData.append('files', fileToUpload, fileToUpload.name);
    formData.append('sector', domain);
    formData.append('subSector', subDomain);
    return this.http.post(endpoint, formData);

}
postFiles(fileToUpload: File,account): Observable<any> {
  const endpoint = '/superadmin/rest/mgmt/b2b';
  const formData: FormData = new FormData();
  formData.append('files', fileToUpload, fileToUpload.name);
  formData.append('account', account);
  return this.http.post(endpoint + '/' + account + '/questionnaire/upload', formData);
}
uploadFile(fileToUpload: File,account,type): Observable<any> {
  const endpoint = '/superadmin/rest/mgmt/spdataimport/account';
  const formData: FormData = new FormData();
  formData.append('files', fileToUpload, fileToUpload.name);
  formData.append('account', account);
  return this.http.post(endpoint + '/' + account + '/upload/' + type , formData);
}
uploadPatientsList(fileToUpload: File,account): Observable<any> {
  const endpoint = '/superadmin/rest/mgmt/account/import/consumer';
  const formData: FormData = new FormData();
  formData.append('files', fileToUpload, fileToUpload.name);
  // formData.append('accId', account);
  // headers.append('Content-Type', 'multipart/form-data');
  const accountId = new Blob(
    [JSON.stringify(account)],
    { type: "application/json" }
  )
  formData.append('accId', accountId);
  // headers.append('Content-Disposition', 'attachment' );
  // headers.append('Content-Length', fileToUpload.size.toString() );
  return this.http.post(endpoint, formData);
}

postZipFile(fileToUpload: File, Importeddate: boolean): Observable<any> {
  const  headers = new HttpHeaders();
  headers.append('Content-Type', 'application/zip');
  headers.append('Content-Disposition', 'attachment' );
  headers.append('Content-Length', fileToUpload.size.toString() );
  const endpoint = '/superadmin/rest/mgmt/account/unclaimedBusinessesUpload';
  const formData: FormData = new FormData();
   formData.append('files', fileToUpload, fileToUpload.name);
   // formData.append('timestamp', Importeddate.toString());
  return this.http.post(endpoint + '/'  + Importeddate  , formData, {headers: headers});

}
// branch corporate file upload.
postbranchCorporateFile(fileToUpload: File, corporate, domain, importedDate): Observable<any> {
  const endpoint = '/superadmin/rest/mgmt/corporate/branch/upload';
  const formData: FormData = new FormData();
  formData.append('files', fileToUpload, fileToUpload.name);
  formData.append('corporateId', corporate);
  formData.append('domain', domain);
  formData.append('timeStamp', importedDate);
  return this.http.post(endpoint, formData);
}
// branch Service provider file  upload
postBspCorporateFile(fileToUpload: File, corporate, domain, importedDate): Observable<any> {
  const endpoint = '/superadmin/rest/mgmt/corporate/branch/sp/upload';
  const formData: FormData = new FormData();
  formData.append('files', fileToUpload, fileToUpload.name);
  formData.append('corporateId', corporate);
  formData.append('domain', domain);
 formData.append('timeStamp', importedDate);
  return this.http.post(endpoint, formData);
}
// branch department file upload
postBdCorporateFile(fileToUpload: File, corporate, domain, importedDate): Observable<any> {
  const endpoint = '/superadmin/rest/mgmt/corporate/branch/department/upload';
  const formData: FormData = new FormData();
  formData.append('files', fileToUpload, fileToUpload.name);
  formData.append('corporateId', corporate);
   formData.append('domain', domain);
  formData.append('timeStamp', importedDate);
  return this.http.post(endpoint, formData);
}
postCorporateZipFile(fileToUpload: File, corporate, branch, importedDate) {

  const  headers = new HttpHeaders();
  headers.append('Content-Type', 'application/zip');
  headers.append('Content-Disposition', 'attachment' );
  headers.append('Content-Length', fileToUpload.size.toString() );
  const endpoint = '/superadmin/rest/mgmt/corporate/corporateUser';
  const formData: FormData = new FormData();
   formData.append('files', fileToUpload, fileToUpload.name);
   formData.append('corporateId', corporate);
  formData.append('branchId', branch);
  formData.append('timeStamp', importedDate);
  return this.http.post(endpoint , formData, {headers: headers});
}
uploadBranchLogo(fileToUpload: File , corporateId): Observable<any> {
  const propertiesDet = {
    'caption': 'logo' // form_data.caption
  };
  const blobPropdata = new Blob([JSON.stringify(propertiesDet)], { type: 'application/json' });
  const endpoint = '/superadmin/rest/mgmt/corporate/branch/' + corporateId ;
  const formData: FormData = new FormData();
  formData.append('files', fileToUpload, fileToUpload.name);
  formData.append('properties', blobPropdata );
  return this.http.post(endpoint, formData);
 }
 postPaymentProfileFile(fileToUpload: File, id): Observable<any> {
  const endpoint = '/superadmin/rest/mgmt/payment/paymentProfile/' +id;
  const formData: FormData = new FormData();
  formData.append('files', fileToUpload, fileToUpload.name);
  return this.http.post(endpoint, formData);
}
postCustomizedJsonFile(fileToUpload: File, id): Observable<any> {
  const endpoint = '/superadmin/rest/mgmt/payment/accountCustomized' +id;
  const formData: FormData = new FormData();
  formData.append('files', fileToUpload, fileToUpload.name);
  return this.http.post(endpoint + '/', formData);
}
}
